export function formatMinutesToHM(totalMinutes) {
  const m = Number(totalMinutes || 0);
  if (!m) return '0m';
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h && rem) return `${h}h ${rem}m`;
  if (h && !rem) return `${h}h`;
  return `${rem}m`;
}

export function formatHoursDecimalToHM(plannedHoursDecimal) {
  const val = Number(plannedHoursDecimal || 0);
  const total = Math.round(val * 60);
  return formatMinutesToHM(total);
}
